var map = {
	"./ANZOR_logo.svg": 577,
	"./Anyswap.png": 402,
	"./Anyswap.svg": 578,
	"./Artwork.svg": 579,
	"./Artwork_gmx.svg": 580,
	"./Banxa.png": 403,
	"./Blp_iconlogo.svg": 581,
	"./DAI.png": 404,
	"./DROP_DOWN.svg": 318,
	"./Hop.png": 405,
	"./Hop.svg": 582,
	"./Hop_dark.png": 406,
	"./Hop_dark.svg": 583,
	"./MVX_logo.svg": 584,
	"./Multichain.png": 239,
	"./Synapse.png": 407,
	"./Synapse.svg": 337,
	"./USDbC.png": 408,
	"./anzor-logo.png": 409,
	"./anzor.png": 410,
	"./axlUSDC.png": 411,
	"./background-2.gif": 585,
	"./background-edge.gif": 586,
	"./banner-avt.9083d854.png": 412,
	"./banner-bg-small.f86fb377.png": 413,
	"./banner-bg.5241de9f.png": 414,
	"./banner-vector.d1966b5c.png": 415,
	"./base-logo.svg": 587,
	"./base.5c12026b.svg": 588,
	"./baseizer-logo-big.png": 416,
	"./baseswap-logo.png": 417,
	"./bg.50b2dacb.png": 418,
	"./binance.png": 419,
	"./blp-logo-text.png": 279,
	"./blp-logo.png": 420,
	"./blp.png": 421,
	"./blp_icon.svg": 589,
	"./bscscan.png": 422,
	"./btn_big_arbitrum.png": 423,
	"./btn_big_avalanche.png": 424,
	"./btn_big_bsc.png": 425,
	"./btn_big_new.svg": 590,
	"./btn_big_purchasegmx.png": 426,
	"./btn_big_purchasegmx.svg": 591,
	"./btn_big_purchasemvx.svg": 592,
	"./buy_gmx.svg": 593,
	"./buy_gmx_bond.svg": 594,
	"./buy_transfer_eth.svg": 595,
	"./cbridgev2.svg": 465,
	"./chainlink.svg": 394,
	"./chart.png": 427,
	"./coinbaseWallet.png": 240,
	"./coingecko.png": 428,
	"./cross.svg": 596,
	"./dollar.png": 429,
	"./dropdown-ic.b57edcbf.svg": 597,
	"./earnlogo.svg": 281,
	"./elp-logo-black-min.png": 275,
	"./eth-homepage.gif": 338,
	"./footerpolygon.svg": 598,
	"./footerpolygonnew.svg": 599,
	"./glp_icon.svg": 600,
	"./gmx-logo-final-white-small.png": 430,
	"./gmx-logo-final-white.png": 431,
	"./gmx-logo-final.png": 432,
	"./gmx-logo-glow.png": 433,
	"./gmx_logo.svg": 601,
	"./graphite-01.png": 434,
	"./home-banner-img.png": 435,
	"./home-bg-old.png": 436,
	"./home-bg.jpg": 602,
	"./home-bg.png": 437,
	"./ic-communityproject.svg": 603,
	"./ic-info.20267414.svg": 604,
	"./ic-mint.dbcd686f.svg": 605,
	"./ic_aave_24.svg": 606,
	"./ic_aave_40.svg": 607,
	"./ic_anzor_40.png": 438,
	"./ic_anzor_40.svg": 608,
	"./ic_arbitrum_16.svg": 609,
	"./ic_arbitrum_24.svg": 610,
	"./ic_arbitrum_96.svg": 611,
	"./ic_arbitrum_hover_16.svg": 612,
	"./ic_avalanche_16.svg": 613,
	"./ic_avalanche_24.svg": 614,
	"./ic_avalanche_96.svg": 615,
	"./ic_avax_24.svg": 616,
	"./ic_avax_30.svg": 617,
	"./ic_avax_40.svg": 618,
	"./ic_axlusdc.png": 439,
	"./ic_axlusdc_24.svg": 619,
	"./ic_axlusdc_30.svg": 620,
	"./ic_axlusdc_40.svg": 621,
	"./ic_axlusdc_96.svg": 622,
	"./ic_banxa.svg": 623,
	"./ic_base_24.svg": 624,
	"./ic_base_30.svg": 625,
	"./ic_base_40.svg": 626,
	"./ic_binance_logo.svg": 627,
	"./ic_blp_24.svg": 628,
	"./ic_blp_40.png": 440,
	"./ic_blp_40.svg": 629,
	"./ic_bsc.svg": 630,
	"./ic_bsc_96.svg": 631,
	"./ic_btc_24.svg": 632,
	"./ic_btc_40.svg": 633,
	"./ic_busd_24.svg": 634,
	"./ic_buy_blp.svg": 339,
	"./ic_buy_glp.svg": 635,
	"./ic_buy_mvlp.svg": 636,
	"./ic_cash.png": 441,
	"./ic_cash.svg": 637,
	"./ic_coingecko_16.svg": 638,
	"./ic_coingecko_hover_16.svg": 320,
	"./ic_convert_down.svg": 319,
	"./ic_copy_16.svg": 313,
	"./ic_cost.svg": 639,
	"./ic_costnew.svg": 640,
	"./ic_dai_24.svg": 641,
	"./ic_dai_40.svg": 642,
	"./ic_discord.svg": 305,
	"./ic_eth_24.svg": 643,
	"./ic_eth_40.svg": 463,
	"./ic_fantom_16.svg": 644,
	"./ic_fantom_24.svg": 645,
	"./ic_fantom_96.svg": 646,
	"./ic_frax_24.svg": 647,
	"./ic_frax_40.svg": 648,
	"./ic_gitbook.svg": 307,
	"./ic_github.svg": 392,
	"./ic_glp_24.svg": 649,
	"./ic_glp_40.svg": 650,
	"./ic_glp_custom.svg": 651,
	"./ic_gmx.svg": 652,
	"./ic_gmx_24.svg": 653,
	"./ic_gmx_30.svg": 654,
	"./ic_gmx_40.svg": 655,
	"./ic_gmx_64.svg": 656,
	"./ic_gmx_arbitrum.svg": 657,
	"./ic_gmx_avax.svg": 658,
	"./ic_gmx_big.svg": 659,
	"./ic_gmx_custom.svg": 660,
	"./ic_gmx_footer.svg": 661,
	"./ic_hop.svg": 662,
	"./ic_info.svg": 663,
	"./ic_link_24.svg": 664,
	"./ic_link_40.svg": 665,
	"./ic_liq.svg": 666,
	"./ic_liquidity.svg": 667,
	"./ic_matic_16.svg": 668,
	"./ic_matic_16new.svg": 669,
	"./ic_matic_24.svg": 670,
	"./ic_matic_40.svg": 671,
	"./ic_medium.svg": 393,
	"./ic_metamask_16.svg": 672,
	"./ic_metamask_hover_16.svg": 198,
	"./ic_mim_24.svg": 673,
	"./ic_mim_40.svg": 674,
	"./ic_multiswap.svg": 675,
	"./ic_mvlp_24.svg": 676,
	"./ic_mvlp_40.png": 442,
	"./ic_mvlp_40.svg": 677,
	"./ic_mvx_40.png": 443,
	"./ic_mvx_40.svg": 678,
	"./ic_new_link_16.svg": 312,
	"./ic_olympus.svg": 679,
	"./ic_olympus_arbitrum.svg": 680,
	"./ic_polygon.svg": 681,
	"./ic_polygon_16.svg": 682,
	"./ic_polygon_24.svg": 683,
	"./ic_selector_dropdowns.svg": 207,
	"./ic_settings_16.svg": 314,
	"./ic_sign in_16.svg": 684,
	"./ic_sign_out_16.svg": 315,
	"./ic_simplenew.svg": 685,
	"./ic_simpleswaps.svg": 686,
	"./ic_stats.svg": 687,
	"./ic_stats_big.svg": 340,
	"./ic_synapse.svg": 688,
	"./ic_telegram.svg": 306,
	"./ic_tether_24.svg": 689,
	"./ic_tokens.svg": 341,
	"./ic_totaluser.svg": 690,
	"./ic_trading.svg": 691,
	"./ic_transfer_avax.svg": 692,
	"./ic_twitter.svg": 304,
	"./ic_uni_24.svg": 693,
	"./ic_uni_40.svg": 694,
	"./ic_usdc.e_24.svg": 695,
	"./ic_usdc.e_40.svg": 696,
	"./ic_usdc_24.svg": 697,
	"./ic_usdc_40.svg": 698,
	"./ic_usdt_24.svg": 699,
	"./ic_usdt_40.svg": 700,
	"./ic_wallet_24.svg": 342,
	"./ic_wavax_24.svg": 701,
	"./ic_wavax_40.svg": 702,
	"./ic_wbase_24.svg": 703,
	"./ic_wbase_40.svg": 704,
	"./ic_weth_24.svg": 705,
	"./ic_weth_40.svg": 706,
	"./ic_wmatic_24.svg": 707,
	"./ic_wmatic_40.svg": 708,
	"./lg_arbitrum.svg": 709,
	"./lg_base.svg": 466,
	"./lg_near.svg": 710,
	"./lg_polygon.svg": 711,
	"./link-green.8997d55b.svg": 712,
	"./link-white.5228d68c.svg": 713,
	"./linktree_white.svg": 395,
	"./liquidation.png": 241,
	"./logo-base.png": 276,
	"./logo-basechain.webp": 94,
	"./logo-blp.png": 444,
	"./logo-blp.svg": 84,
	"./logo-eth.png": 152,
	"./logo-fantom.png": 445,
	"./logo_ANZOR.svg": 714,
	"./logo_ANZOR_small.svg": 715,
	"./logo_MVX.svg": 716,
	"./long.svg": 334,
	"./lzusdc.webp": 717,
	"./man.png": 446,
	"./manage-swaps.png": 447,
	"./metamask-text.svg": 718,
	"./metamask.png": 448,
	"./money.png": 449,
	"./mum1.826066ac.png": 450,
	"./mum2.19e61eee.png": 451,
	"./mvlp.png": 452,
	"./mvx.png": 453,
	"./mvxheader.svg": 719,
	"./nfts/base-footer-banner-left.png": 454,
	"./nfts/base-footer-banner-right.png": 455,
	"./nfts/base-nft-banner-avatar.png": 456,
	"./open-interest.png": 457,
	"./openinterest.png": 242,
	"./openinterest.svg": 720,
	"./page-not-found.svg": 721,
	"./placeholder.svg": 722,
	"./save-costs.png": 243,
	"./short.svg": 335,
	"./simple-swaps.png": 244,
	"./solid_background_3.png": 458,
	"./swap.svg": 336,
	"./swapbased-logo.png": 82,
	"./total-users.png": 245,
	"./total-volume.png": 246,
	"./totalusers.svg": 723,
	"./totalvolume.png": 459,
	"./trading.png": 460,
	"./wallet-connect-text.svg": 724,
	"./walletconnect-circle-blue.svg": 343,
	"./wave-01.png": 461,
	"./wave-02.png": 462,
	"./xpollinate.svg": 467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280;